(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sm-bis"] && !Shopify.designMode) return;
  try {
    // Eén gedelegeerde handler voor elk BIS-formulier op de pagina, nu en later.
  (function () {
    if (window.__smBis) return;
    window.__smBis = true;

    var REVISIE = '2026-01-15';

    function melden(form, tekst, stand) {
      var el = form.querySelector('.bis-melding');
      if (!el) return;
      el.setAttribute('data-stand', stand);
      el.textContent = tekst;
    }

    function post(pad, key, body) {
      return fetch('https://a.klaviyo.com/client/' + pad + '/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISIE },
        body: JSON.stringify(body)
      });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('form[data-bis]') : null;
      if (!form) return;
      e.preventDefault();

      var veld = form.querySelector('.bis-mail');
      var knop = form.querySelector('.bis-knop');
      var mail = veld ? veld.value.trim() : '';
      var key = form.getAttribute('data-bis-key');
      var variant = form.getAttribute('data-bis-variant');

      // Dezelfde toets die Klaviyo zelf doet. `type="email"` vangt het meeste al
      // af, maar novalidate staat aan omdat de browsermelding niet te stylen is.
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
        if (veld) {
          veld.setAttribute('aria-invalid', 'true');
          veld.focus();
        }
        melden(form, 'Vul een geldig e-mailadres in.', 'fout');
        return;
      }
      if (veld) veld.removeAttribute('aria-invalid');
      if (knop) knop.disabled = true;

      post('back-in-stock-subscriptions', key, {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: mail } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } }
          }
        }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Klaviyo ' + res.status);

          var rij = form.querySelector('.bis-rij');
          var uitleg = form.querySelector('.bis-uitleg');
          melden(form, 'Gelukt — je krijgt bericht zodra dit weer op voorraad is.', 'klaar');

          // Focus eerst verplaatsen, dán pas de rij weghalen. De focus stond op de
          // knop of het veld en die zitten allebei ín die rij; verdwijnt hij eerst,
          // dan valt de focus terug naar <body> en verliest een toetsenbord- of
          // schermlezergebruiker zijn plek precies op het moment dat de melding
          // voorgelezen moet worden.
          var melding = form.querySelector('.bis-melding');
          if (melding) melding.focus();
          if (rij) rij.hidden = true;
          if (uitleg) uitleg.hidden = true;
        })
        .catch(function () {
          melden(form, 'Er ging iets mis. Probeer het zo nog eens.', 'fout');
          if (knop) knop.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-filterbalk"] && !Shopify.designMode) return;
  try {
    // Verrijking, geen voorwaarde: zonder JS submit de bezoeker met de knop uit
  // <noscript>. Hier vervangt een wijziging die klik.
  //
  // Gedelegeerd op document, niet per formulier: dit blok draait één keer per
  // paginalading, terwijl de theme-editor de sectie opnieuw rendert bij elke
  // instelling. Een direct gebonden listener is daarna weg en de balk doet dan
  // niets meer — de noscript-knop staat er niet als JS aan staat.
  document.addEventListener('change', (e) => {
    e.target.closest('[data-fbar-form]')?.submit();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-sticky-koop"] && !Shopify.designMode) return;
  try {
    /* De balk verschijnt zodra het koopblok naar BÓVEN uit beeld is — niet wanneer
     het er nog ónder staat, want bij het laden van de pagina is het koopblok ook
     "niet zichtbaar" en dan hoort er geen balk te staan.

     ⚠ Een rect-meting op scroll, en géén IntersectionObserver, terwijl het
     ontwerp (Pdp.jsx) die wél gebruikt. Gemeten op de pakket-PDP in de preview
     van 28-08: de observer bleef daar dood. Hij werd aangemaakt, kreeg zijn
     anker en zijn eerste callback, en reageerde daarna nergens meer op — terwijl
     een handmatige tweede init hem meteen liet werken, en een verse observer met
     exact dezelfde parameters vanuit de console óók. Nagegaan en uitgesloten:
     het snippet stond in `data-snippets` (de bundel-guard liet dus door), er was
     precies één balk en één anker, en een MutationObserver op #sm-main zag over
     vier seconden geen enkele vervanging van beide knopen. Op de losse-maaltijd-
     PDP werkte dezelfde code wél. Het verschil is niet gevonden; wat vaststaat is
     dat de uitkomst per pagina verschilde.

     Een rect-meting heeft dat probleem niet: er is geen registratie die stil kan
     verlopen, alleen een getal dat je uitrekent op het moment dat je het nodig
     hebt. Kosten: één `getBoundingClientRect()` per animatieframe waarin er
     gescrold is, achter een rAF-slot en passieve listeners. Dat is de ruil
     waarvoor je een elegantere API laat staan — de goedkopere oplossing die stil
     faalt, is de dure.

     De aanleiding om hier überhaupt naar te kijken was de Codex-review van
     28-08: die wees erop dat de pakket-PDP zijn stappen 1-3 afhandelt met
     `hoofd.innerHTML = …` (`wissel()` in sm-pakket), waardoor deze balk — die
     binnen #sm-main staat — door een verse kopie vervangen wordt. Vandaar het
     `sm:hoofd-vervangen`-signaal en de gedelegeerde submit-handler hieronder:
     beide overleven zo'n vervanging. */
  (() => {
    let gepland = false;

    const meet = () => {
      gepland = false;
      const balk = document.querySelector('[data-sticky-koop]');
      if (!balk) return;
      const anker = document.querySelector(balk.dataset.anker);
      /* Geen anker: de balk blijft weg. Liever geen balk dan een balk die nooit
         meer weggaat. Het `hidden`-attribuut staat in de markup en gaat er hier
         af, zodat de balk zonder JS ook niet half zichtbaar blijft hangen. */
      if (!anker) return;
      balk.hidden = false;
      /* 80px is de headerhoogte: de balk komt zodra het koopblok áchter de vaste
         header verdwenen is, niet zodra het de onderrand raakt. */
      balk.classList.toggle('on', anker.getBoundingClientRect().bottom < 80);
    };

    const plan = () => {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(meet);
    };

    /* Passief: deze listeners roepen nooit preventDefault aan, en zonder die vlag
       houdt de browser het scrollen tegen tot hij dat weet. */
    addEventListener('scroll', plan, { passive: true });
    addEventListener('resize', plan, { passive: true });
    /* Na een stap-1-t/m-3-wissel op de pakket-PDP staat er een verse balk in de
       DOM. Omdat deze opzet niets op een element registreert, volstaat één
       hermeting — er is geen observer die opnieuw gekoppeld moet worden. */
    document.addEventListener('sm:hoofd-vervangen', plan);
    addEventListener('load', plan);
    meet();

    /* Variant én aantal uit het hoofdformulier meenemen, op `submit` en niet bij
       elke wijziging: de kiezer kan een input, een select of een stepper zijn, en
       alleen de stand op het moment van versturen telt. Gedelegeerd op `document`
       en niet op het formulier zelf, zodat een balk die na een wissel vervangen
       is meteen meedoet — dezelfde reden waarom de drawer zijn submit-handler
       daar heeft hangen. */
    document.addEventListener('submit', (e) => {
      const form = e.target.closest && e.target.closest('.sticky-form');
      if (!form) return;
      const balk = form.closest('[data-sticky-koop]');
      const anker = balk && document.querySelector(balk.dataset.anker);
      if (!anker) return;

      const qtyVeld = form.querySelector('[data-sticky-qty]');
      if (qtyVeld) {
        const bron = anker.querySelector('[name="quantity"]');
        const n = bron ? parseInt(bron.value, 10) : 1;
        qtyVeld.value = Number.isFinite(n) && n > 0 ? n : 1;
      }
      /* Alleen overnemen als het hoofdformulier écht een variant-id voert én die
         gevuld is; anders blijft de server-gerenderde waarde staan. Een leeg `id`
         maakt van /cart/add een 422, en dat is erger dan de terugval. */
      const idVeld = form.querySelector('[data-sticky-id]');
      if (idVeld) {
        const bronId = anker.querySelector('[name="id"]');
        if (bronId && bronId.value) idVeld.value = bronId.value;
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
